<template>
    <div class="animated fadeIn" v-if="is(condition)">
        <b-card>
            <b-form-group label="Наименование условия">
                <input v-model="condition.title" class="form-control" />
            </b-form-group>
            <b-form-group label="Идентификатор условия">
                <div class="input-group">
                    <span class="input-group-text" value="sm">sm</span>
                    <input v-model="condition.slug" class="form-control" />
                </div>
            </b-form-group>
            <b-form-group label="Описание условия">
                <textarea v-model="condition.info" class="form-control"></textarea>
            </b-form-group>
            <b-form-group>
                <button @click="doSave()"><i class=""></i> Сохранить</button>
            </b-form-group>
        </b-card>
    </div>
</template>

<script>
    import { functions } from '@/functions';
    import { functions_sm } from '@/functions_sm.js';

    export default {
        name: 'SmCondition',
        components: {},
        mixins: [functions, functions_sm],
        data: function () {
            return {
                condition:null,
                condition_id:null,
                conditions:[],
                input:false,
                show_create_modal:false,
                show_delete_modal:false,
                title:null,
                slug:null,
                info:null,
                cur:null,
            }
        },
        created: function() {
        },
        methods: {

            doSave:function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('sm/condition/'+this.condition_id+'/save'), {condition:this.condition}).then(function (response) {
                    response = this.httpSuccess(response);
                    this.loadCondition();
                }, this.httpError);
            }
        },
        watch: {
            '$route.params': {
                handler(newValue) {
                    if (newValue) {
                        this.condition_id = this.$router.currentRoute.params.condition_id;
                        this.loadCondition();
                    }
                },
                immediate: true,
            },
        }
    };
</script>

<style lang="scss"></style>
